import { render } from "./MyLogin.vue?vue&type=template&id=388e7ea6"
import script from "./MyLogin.vue?vue&type=script&lang=js"
export * from "./MyLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__